import { FRONT_GENERAL_CONFIG } from "@front-shared/config/general.config.ts"

export enum ActiveCoverageNoticeType {
    planActiveAtRisk = "planActiveAtRisk",
    partialCoverage = "partialCoverage",
}

export const GENERAL_CONFIG = {
    // Common values from our elements library that can be overridden here if needed
    ...FRONT_GENERAL_CONFIG,

    defaultPageTitle: "Out-of-Network Reimbursement Calculator",

    pdfGenerationIgnoreClassName: "nirvana-pdf-ignore",
}
